import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedDataService } from './service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { PageReloadService } from './service/page-reload/page-reload.service';
import { VoiceAgentService } from './service/voice-assistance/voice-agent.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './service/auth-service/auth.service';
import { FireworksService } from './service/fireworks/fireworks.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  user: any;
  timeoutId;

  constructor(
    private sharedDataService: SharedDataService,
    private voiceAgentService: VoiceAgentService,
    private reloadService: PageReloadService,
    private authService: AuthService,
    private fireworksService: FireworksService,
  ) {
    // Initialize active language on app startup
    const savedLang = localStorage.getItem('selectedLanguage') || 'en';
  }

  ngOnInit() {
    // this.fireworksService.start();
    this.reloadService.startReloading(12 * 60); // Reload every 24 mins
    this.getUserDetails();
  }

  getUserDetails() {
    this.sharedDataService
    .getUser()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.isLoggedIn = true;
          this.timeoutId = setTimeout(() => {
            if (this.user.isAllowVoiceAssistance) {
              const token = this.authService.getToken('token');
              const payload = {
                isallowwidget: this.user.isAllowVoiceAssistance,
                credentials: {
                  webhookUrl: environment.baseUrl,
                  webhookToken: 'JWT ' + token,
                  defaultTimezone: this.user.timeZone,
                  company: this.user && this.user.company ? this.user.company._id : this.user._id
                }
              }
              this.voiceAgentService.init(payload);
            } else {
              this.voiceAgentService.destroy();
            }
          }, 2000);
      } else {
        this.voiceAgentService.destroy();
        this.isLoggedIn = false;
      }
    });
  }

  ngOnDestroy(): void {
     if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
  }

}




